module.exports = __webpack_public_path__ + "static/img/8.b9e5d1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/8.png
// module id = jFev
// module chunks = 0